<gbc-tile title="{{ title | translate }}" class="error-tile">
  <p class="error-tile-content">
    {{ message | translate }}
  </p>
</gbc-tile>
